import React, { useState, useEffect } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import Axios from "axios";
import AccessDenied from "../components/AccessDenied";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  MDBCardTitle,
  MDBCardText,
  MDBTooltip,
  MDBCardHeader,
  MDBCardBody,
  MDBCard,
  MDBCardFooter,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBModalHeader,
  MDBModalBody,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
} from "mdbreact";
import AddEditItem from "./AddEditItem";

const PriceCheckerTable = (props) => {
  const TitleBar = () => {
    return (
      <React.Fragment>
        <h5
          style={{
            fontFamily: "Roboto",
            fontWeight: "600",
            fontSize: "1em",
            padding: "0",
          }}
          className="brown-text h5-responsive pt-4"
        >
          {props.title}
        </h5>

        <p className="small">{props.description}</p>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <MaterialTable
        title={<TitleBar></TitleBar>}
        components={{
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              {/* <MDBContainer>
  
                          
                            <MDBRow className='pb-1'>
                              <MDBCol size="12">
                              <a href="#" onClick={searchqrcode}></a><MDBIcon icon="qrcode" size="3x" className='float-right green-text'/>
                              </MDBCol>
                              </MDBRow> 
                              </MDBContainer> */}
            </div>
          ),
        }}
        columns={[
          { title: "", field: "code", hidden: true, searchable: true },
          {
            title: "Item Full Details",
            field: "ItemsServicesDescription",
          },
          { title: "Brand", field: "brand" },
          { title: "Generic", field: "generic" },
          { title: "Description", field: "description" },

          { title: "Selling Price / Service Cost", field: "sellingprice" },
          { title: "Discountable", field: "discountable" },
          { title: "Category", field: "itemcategory" },
        ]}
        data={props.rows}
        //   options={{
        //     search: true,
        //     actionsColumnIndex: -1
        //     ,filtering:true
        //   }}

        options={{
          search: true,
          actionsColumnIndex: -1,
          filtering: true,

          cellStyle: {
            width: "100%",
            paddingLeft: "20px",
          },
        }}

        //   detailPanel={[
        //   {
        //   icon: ()=> <MDBIcon icon="edit" className="cyan-text" />,
        //   openIcon: ()=><MDBIcon icon="chevron-down"  className="red-text" />,
        //   tooltip:"Item Details",
        //   render: rowData => {
        //   return (

        //   <React.Fragment>

        //     <AddEditItem

        //         deployURL={props.deployURL}
        //         apiServer={props.apiServer}
        //         itemcode={rowData.code }
        //         apiServerHybrid={props.apiServerHybrid}
        //         toggleModal={props.toggleAddEdit}
        //         refreshGrid={props.refreshGrid}

        //     />
        //   </React.Fragment>

        //   )
        //   }

        //   }
        //     ]}
      />
    </React.Fragment>
  );
};

//
export default PriceCheckerTable;
